export default "__VITE_ASSET__BS7LxNRI__"